export const stringToArray = (strIn: string, separator: string): string[] => {
    if (!strIn || strIn?.length === 0) {
        return [];
    }

    if (!strIn.includes(separator)) {
        return [strIn.trim()];
    }

    const array = strIn.split(separator);
    return array.map((value) => value.trim());
};
